module.exports = __webpack_public_path__ + "static/media/theme_abstraction.d0e59301.mp3";